import React, {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import ChatInputArea from './chatInputArea';
import ChatmsgItem from './chatmsgItem';
import ChatHeader from './chatHeader';
import classNames from 'classnames';
import InfinitScroll from 'components/infinitScroll';
interface ChatFormContinerProps {
  chatId?: string;
  isReportOpen: boolean;
  isScrollLoading: boolean;
  elements: Array<ISampleCHatlist>;
  onWatchEnd: () => void;
  refresh: () => void;
  setIsReportOpen: (isReportOpen: boolean) => void;
}
const ChatFormContiner = ({
  chatId,
  elements,
  isReportOpen,
  isScrollLoading,
  setIsReportOpen,
  refresh,
  onWatchEnd,
}: ChatFormContinerProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const {state} = useLocation();

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView();
  };

  useEffect(() => {
    scrollToBottom();
  }, []);
  return (
    <div className="bg-[#F5F5F5] w-full h-full flex flex-col justify-center relative">
      <ChatHeader
        isReportOpen={isReportOpen}
        chatId={chatId}
        name={state?.name}
        imgUrl={state?.imgUrl}
        setIsReportOpen={setIsReportOpen}
      />
      <div className="w-full flex flex-col-reverse gap-4 max-h-[100vh] h-[83%] items-start overflow-y-auto px-2 py-4">
        <div ref={messagesEndRef} />
        <InfinitScroll isloading={isScrollLoading} onWatchEnd={onWatchEnd}>
          {elements?.map((item, index) => {
            return (
              <div
                className={classNames(
                  'flex flex-col gap-4 px-4 w-full',
                  {
                    'items-start': item.is_author,
                  },
                  {'items-end': !item.is_author},
                )}
                key={index}
              >
                <ChatmsgItem chat={item} />
              </div>
            );
          })}
        </InfinitScroll>
      </div>
      <ChatInputArea
        refresh={refresh}
        onWatchEnd={onWatchEnd}
        chatId={chatId}
      />
    </div>
  );
};

export default ChatFormContiner;
